const languages = {
  "zh-TW": {
    label: "繁體中文",
    shortLabel: "中文",
  },
  en: {
    label: "English",
    shortLabel: "EN",
  },
};

export default languages;
